import { Button } from '@/shared/components/shadcn/button';

type ScrapingPaginationProps = {
  hasMore: boolean;
  canGoBack: boolean;
  isFetching: boolean;
  onNext: () => void;
  onBack: () => void;
};

export function ScrapingPagination({
  hasMore,
  canGoBack,
  isFetching,
  onNext,
  onBack,
}: ScrapingPaginationProps) {
  if (!hasMore && !canGoBack) {
    return null;
  }

  return (
    <div className="flex items-center justify-end gap-2 py-4">
      <Button variant="outline" size="sm" disabled={!canGoBack || isFetching} onClick={onBack}>
        Previous
      </Button>
      <Button variant="outline" size="sm" disabled={!hasMore || isFetching} onClick={onNext}>
        Next
      </Button>
    </div>
  );
}
